import { eventChannel, Subscribe, Buffer } from 'redux-saga';
import Logger from '../../services/Logger';
import { gtag } from '../../utils/ga';

const logger = new Logger(`GoogleOptimize`, {
  prefixColor: '#6540b5',
});

export interface ExperimentChannelValue {
  id: string;
  value: string;
}

export const googleOptimizeSubscriber: Subscribe<ExperimentChannelValue> = (
  emit
) => {
  const optimizeCallback = (value: string, name: string) => {
    // puts event payload into the channel
    // this allows a Saga to take this payload from the returned channel
    logger.log(`Value: ${value}, Name: ${name}`);

    emit({ value, id: name });
  };

  // setup the subscription
  gtag('event', 'optimize.callback', { callback: optimizeCallback });

  logger.info(`Callback initialized`);
  // the subscriber must return an unsubscribe function
  // this will be invoked when the saga calls `channel.close` method
  return () => {
    gtag('event', 'optimize.callback', {
      callback: optimizeCallback,
      remove: true,
    });
    logger.info('Callback destroyed');
  };
};

// TODO: unit-tests
export function createExperimentChannel(
  buffer: Buffer<ExperimentChannelValue>
) {
  // `eventChannel` takes a subscriber function
  // the subscriber function takes an `emit` argument to put messages onto the channel
  return eventChannel(googleOptimizeSubscriber, buffer);
}
